import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom'
import DashboardPage from './pages/DashboardPage'
import UploadPage from './pages/UploadPage'
import ChatPage from './pages/ChatPage'
import Home from './pages/Home'
import VerifyPage from './pages/VerifyPage'
import AnnouncementsPage from './pages/AnnouncementsPage'
import LoginPage from './pages/LoginPage'
import ProtectedRoute from './components/ProtectedRoute'
import SignUpPage from './pages/SignUpPage'
import PlansByGroupPage from './pages/PlansByGroupPage'
import TestPdfUploadPage from './pages/TestPdfUploadPage'
import { supabase } from './supabaseClient'
import TestRedactionPage from './pages/TestRedactionPage'
import ViewPlanPage from './pages/ViewPlanPage'
import FeedbackPage from './pages/FeedbackPage'
import FaqPage from './pages/FaqPage'
import ThankYouPage from './pages/ThankYouPage';
import CuvrIQBetaOverview from "./pages/CuvrIQBetaOverview";
import CuvrIQBeta from "./pages/CuvrIQBeta";
import CuvriqVideoPage from './pages/CuvriqVideoPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import AccessPendingPage from './pages/AccessPendingPage';
import AdminApprovalsPage from './pages/AdminApprovalsPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DisclaimerPage from './pages/DisclaimerPage'

function AutoLogout() {
  const navigate = useNavigate()

  useEffect(() => {
    const timeoutDuration = 15 * 60 * 1000 // 15 minutes
    let logoutTimer

    const handleLogout = async () => {
      await supabase.auth.signOut()
      navigate('/login', { replace: true })
    }

    const resetTimer = () => {
      clearTimeout(logoutTimer)
      logoutTimer = setTimeout(() => {
        handleLogout()
      }, timeoutDuration)
    }

    // Track user activity
    window.addEventListener('mousemove', resetTimer)
    window.addEventListener('keydown', resetTimer)
    window.addEventListener('click', resetTimer)
    window.addEventListener('scroll', resetTimer)

   
    resetTimer()

    return () => {
      clearTimeout(logoutTimer)
      window.removeEventListener('mousemove', resetTimer)
      window.removeEventListener('keydown', resetTimer)
      window.removeEventListener('click', resetTimer)
      window.removeEventListener('scroll', resetTimer)
      
    }
  }, [navigate])

  return null
}

function App() {
  return (
    <Router>
      <AutoLogout />

      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/access-pending" element={<AccessPendingPage />} />
        <Route path="/test-redact" element={<TestRedactionPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/beta-invite" element={<CuvrIQBetaOverview />} />
        <Route path="/beta" element={<CuvrIQBeta />} />
        <Route path="/cuvriq-video" element={<CuvriqVideoPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />  
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={['admin', 'standard', 'demo']}>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/upload"
          element={
            <ProtectedRoute allowedRoles={['admin', 'standard']}>
              <UploadPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chat"
          element={
            <ProtectedRoute allowedRoles={['admin', 'standard', 'demo']}>
              <ChatPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/test-pdf"
          element={
            <ProtectedRoute allowedRoles={['admin', 'standard']}>
              <TestPdfUploadPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/home"
          element={
            <ProtectedRoute allowedRoles={['admin', 'standard']}>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/plans-by-group"
          element={
            <ProtectedRoute allowedRoles={['admin', 'standard']}>
              <PlansByGroupPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/verify/:rowId"
          element={
            <ProtectedRoute allowedRoles={['admin', 'standard']}>
              <VerifyPage />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/view-plan/group/:groupId"
            element={
              <ProtectedRoute allowedRoles={['admin', 'standard']}>
                <ViewPlanPage />
              </ProtectedRoute>
            }
        />
        <Route
          path="/faq"
          element={
            <ProtectedRoute allowedRoles={['admin', 'standard', 'demo']}>
              <FaqPage />
            </ProtectedRoute>
          }
        />  
        <Route 
          path="/Feedback"
            element={
              <ProtectedRoute allowedRoles={['admin', 'standard']}>
                <FeedbackPage />
              </ProtectedRoute>
            }
        />
        <Route
  path="/admin/users"
  element={
    <ProtectedRoute allowedRoles={['admin']}>
      
        <AdminApprovalsPage />
      
    </ProtectedRoute>
  }
/>

        <Route path="/announcements" element={<AnnouncementsPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute allowedRoles={['admin', 'standard']}>
              <Navigate to="/dashboard" />
            </ProtectedRoute>
          }
        />
        
      </Routes>
    </Router>
  )
}

export default App
